import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">视频分类</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">十大精选分类，总有一类适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${cat.icon} text-primary-500 group-hover:text-background-50 text-xl md:text-2xl transition-colors duration-200`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.count}个视频</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}